import { useEffect } from "react";
import PaymentReportComp from '../Components/PaymentReport/PaymentReport';
const PaymentReport = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <PaymentReportComp />
    </div>
  );
};

export default PaymentReport;